import { TRANSLATION_KEYS } from '../../../../../../../translations'

export const positiveHeaders = [
  TRANSLATION_KEYS.settings.qbrHighlightPositiveHeaderFirst,
  TRANSLATION_KEYS.settings.qbrHighlightPositiveHeaderSecond,
]
export const negativeHeaders = [
  TRANSLATION_KEYS.settings.qbrHighlightNegativeHeaderFirst,
  TRANSLATION_KEYS.settings.qbrHighlightNegativeHeaderSecond,
]

export const COLORS = {
  redColor: '#DD3A3C',
  yellowColor: '#FCF64A',
  greenColor: '#29CD84',
}

export const SPLIT_NON_DIGITS_REGEX = /\D+/g
